<script lang="ts">
	import fb from "../../../../core/assets/icons/fb.svg?raw";
	import ig from "../../../../core/assets/icons/ig.svg?raw";
	import yt from "../../../../core/assets/icons/yt.svg?raw";
	import fastest from "@core/assets/icons/logo - fastest.svg?raw";
	import { getPrivacyPolicyPath } from "@core/schema/paths/getPrivacyPolicyPath.js";
	import { ZmsFb } from "@core/utils/ZmsFb.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import { getTranslate } from "../../utils/getTranslate.js";
	import Formatted from "../common/Formatted.svelte";
	import Icon from "../common/Icon.svelte";
	import Link from "../common/Link.svelte";
	import { ButtonVariant } from "../common/getButtonClass.js";
	import { email } from "../email.js";
	import { phoneNumber } from "../phoneNumber.js";
	import translation from "./Footer.translations.json" with { type: "json" };

	const { tenant } = getGlobalTemplateProps();

	const translate = getTranslate(translation);
</script>

<footer
	class="full-width relative bg-zms-blue pt-12 sm:pt-16 md:pt-20 lg:pt-[5.5rem] pb-16 sm:pb-20 md:pb-24 lg:pb-[11.875rem] text-white flex grid-container"
>
	<div class="container-center">
		<div
			class="grid grid-cols-1 md:grid-cols-2 xl:[grid-template-columns:1.8fr_1fr_1.3fr] gap-8 sm:gap-10 md:gap-12 lg:gap-16 mb-12 sm:mb-14 md:mb-16"
		>
			<div class="flex flex-col gap-6 sm:gap-8 md:gap-5 lg:gap-[192px]">
				<div class="flex flex-col gap-3 sm:gap-4 md:gap-2 lg:gap-6">
					<span class="font-normal text-xs sm:text-sm/[1] tracking-[0.04em] uppercase"
						><Formatted text={translate("about")} /></span
					>
					<p class="font-semibold text-base sm:text-lg md:text-[1.125rem]/[1.4] text-white">
						<Formatted text={translate("aboutText")} />
					</p>
				</div>
				<div class="flex flex-col gap-3 sm:gap-4 md:gap-2 lg:gap-6">
					<span class="font-medium text-xs sm:text-sm/[1] tracking-[0.04em] uppercase"
						><Formatted text={translate("followUs")} /></span
					>
					<div class="flex gap-3 sm:gap-4">
						<Link href={ZmsFb} target="_blank" aria-label="Facebook">
							<Icon icon={fb} class="h-7 w-7 sm:h-8 sm:w-8" />
						</Link>
						<Link href="https://www.instagram.com/zmservismoravia/" target="_blank" aria-label="Instagram">
							<Icon icon={ig} class="h-7 w-7 sm:h-8 sm:w-8" />
						</Link>
						<Link href="https://www.youtube.com/@zmservismoravias.r.o.2807" target="_blank" aria-label="YouTube">
							<Icon icon={yt} class="h-7 w-7 sm:h-8 sm:w-8" />
						</Link>
					</div>
				</div>
			</div>

			<div class="flex flex-col gap-3 sm:gap-4 md:gap-2 lg:gap-6">
				<span class="font-normal text-xs sm:text-sm/[1] tracking-[0.04em] uppercase"
					><Formatted text={translate("based")} /></span
				>
				<Link href="https://maps.app.goo.gl/if2QQckcqNzM3fTT7" target="_blank" variant={ButtonVariant.Transparent}>
					<address class="font-semibold text-base sm:text-lg md:text-[1.125rem]/[1.4] text-white">
						Lánská&nbsp;298,&nbsp;Kanada<br />739&nbsp;61&nbsp;Třinec
					</address>
				</Link>
			</div>

			<div class="flex flex-col gap-6 sm:gap-8 md:gap-4 lg:justify-between">
				<div class="flex flex-col gap-3 sm:gap-4 md:gap-2 lg:gap-6">
					<span class="font-normal text-xs sm:text-sm/[1] tracking-[0.04em] uppercase"
						><Formatted text={translate("phone")} /></span
					>
					<Link
						href="tel:{phoneNumber.replace(/\s+/gu, '')}"
						class="font-semibold text-base sm:text-lg md:text-[1.125rem]/[1.4] text-white"
						>+420&nbsp;603&nbsp;722&nbsp;624</Link
					>
				</div>
				<div class="flex flex-col gap-3 sm:gap-4 md:gap-2 lg:gap-6">
					<span class="font-normal text-xs sm:text-sm/[1] tracking-[0.04em] uppercase"
						><Formatted text={translate("email")} /></span
					>
					<Link href="mailto:{email}" class="font-semibold text-base sm:text-lg md:text-[1.125rem]/[1.4] text-white"
						>{email}</Link
					>
				</div>
				<div class="flex flex-col gap-3 sm:gap-4 md:gap-2 lg:gap-6">
					<span class="font-normal text-xs sm:text-sm/[1] tracking-[0.04em] uppercase"
						><Formatted text={translate("cin")} /></span
					>
					<p class="font-semibold text-base sm:text-lg md:text-[1.125rem]/[1.4] text-white">27785807</p>
				</div>
				<div class="flex flex-col gap-3 sm:gap-4 md:gap-2 lg:gap-6">
					<span class="font-normal text-xs sm:text-sm/[1] tracking-[0.04em] uppercase"
						><Formatted text={translate("tin")} /></span
					>
					<p class="font-semibold text-base sm:text-lg md:text-[1.125rem]/[1.4] text-white">CZ27785807</p>
				</div>
			</div>
		</div>
		<span class="font-normal text-lg md:text-2lg/[1.1] font-hubot -tracking-[0.02em]">ZM Servis Moravia s. r. o.</span>
		<div
			class="mt-12 sm:mt-14 md:mt-16 grid grid-cols-1 xl:[grid-template-columns:1.8fr_1fr_1.3fr] gap-8 sm:gap-10 md:gap-12 lg:gap-16"
		>
			<span class="text-xs sm:text-sm flex gap-1 items-start md:text-sm/[1.4] tracking-[0.04em]">
				<span class="text-nowrap md:text-wrap text-xs sm:text-sm md:text-sm/[1.4] mr-0.5"
					><Formatted text={translate("fastest")} />
				</span>
				<Link
					variant={ButtonVariant.Transparent}
					href="https://www.fastest.cz"
					target="_blank"
					aria-label="Fastest.cz"
					class="font-semibold text-xs/[1.2] sm:text-sm/[1.4] md:text-sm/[1.4] uppercase tracking-[0.04em]"
				>
					<Icon icon={fastest} class="h-5 pb-1" />
				</Link>
			</span>
			<div class="flex justify-normal gap-4 sm:gap-6 md:gap-8">
				<!-- <Link
					variant={ButtonVariant.Transparent}
					href="TODO"
					class="font-semibold text-xs/[1.2] sm:text-sm/[1.4] md:text-sm/[1.4] uppercase tracking-[0.04em]"
				>
					<Formatted text={translate("terms")} />
				</Link> -->
				<Link
					variant={ButtonVariant.Transparent}
					href={getPrivacyPolicyPath(tenant)}
					class="font-semibold text-xs/[1.2] sm:text-sm/[1.4] md:text-sm/[1.4] uppercase tracking-[0.04em]">gdpr</Link
				>
			</div>
			<span
				class="text-xs flex gap-2 pr-3 justify-start items-center sm:text-sm md:text-xs/[1.4] font-normal tracking-[0.04em]"
			>
				<span class="text-nowrap md:text-wrap text-xs sm:text-sm md:text-sm/[1.4]">
					<Formatted text={translate("copy")} />
					<Formatted text="ZMS Servis Moravia s. r. o." />
				</span>
			</span>
		</div>
	</div>
</footer>
